export const individual_questions = [
  {
    name: 'registration_revoked',
    label: 'Have you ever had your registration, membership or privileges, suspended, revoked or conditioned, by a government, regulatory authority, exchange/clearing organization?'
  },
  {
    name: 'convicted_felon',
    label: 'In the last ten years, have you ever been convicted of, or plead "no contest" to a felony?'
  },
  {
    name: 'misdemeanor',
    label: 'In the last five years, have you ever been convicted of, pled guilty or "no contest" to any misdemeanor that involves embezzlement, theft, fraud, extortion, misappropriation of funds, forgery or bribery?'
  },
  {
    name: 'under_investigation',
    label: 'Are you currently subject to an investigation (excluding routine financial audits and examinations) by any government or regulatory authority, or exchange/clearing organization?'
  },
];

export const entity_questions = [
  {
    name: 'registration_revoked',
    label: 'Has any person, officer, managing member, partner or person who owns 10% or more of the applicant ever had their registration, membership or privileges, suspended, revoked or conditioned, by a government, regulatory authority, exchange or clearing organization?'
  },
  {
    name: 'convicted_felon',
    label: 'In the past ten years, has any person, officer, managing member, partner or person who owns 10% or more of the applicant, been convicted of, or plead "no contest" to a felony?'
  },
  {
    name: 'misdemeanor',
    label: 'In the past five years, has any person, officer, managing member, partner or person who owns 10% or more of the applicant, ever been convicted of, pled guilty or "no contest" to any misdemeanor that involves embezzlement, theft, fraud, extortion, misappropriation of funds, forgery or bribery?'
  },
  {
    name: 'under_investigation',
    label: 'Has any person, officer, managing member, partner or person who owns 10% or more of the applicant, currently subject to an investigation (excluding routine financial audits and examinations) by any government or regulatory authority, or exchange/clearing organization?'
  },
];
